import React, { useContext, useEffect, useState } from 'react'
import ContentHeader from '../../../../Components/Layout/ContentHeader'
import LayoutTable from '../../../../Components/Global/LayoutTable'
import { useMutation, useQuery } from '@apollo/client'
import {
  DELETE_HUMAN_RESOURCES,
  GET_HUMAN_RESOURCES,
} from '../../../../graphql/Catalog/HumanResources/humanResources'
import { toastSweetAlert } from '../../../Helpers/ToastSweetAlert'
import { Link, useLocation } from 'react-router-dom'
import { AuthContext } from '../../../../Auth/AuthContext'
import withReactContent from 'sweetalert2-react-content'
import Swal from 'sweetalert2'

const extraRef = {
  query: GET_HUMAN_RESOURCES,
  variables: {
    limit: null,
    offset: null,
  },
}

const HumanResources = () => {
  const MySwal = withReactContent(Swal)

  // ------------ HOOKS ------------
  const { user } = useContext(AuthContext)
  const location = useLocation()

  const [pagePagination, setPagePagination] = useState({
    searchQuery: null,
    limit: 10,
    offset: 0,
  })
  const [total, setTotal] = useState(0)
  const [dataToTable, setDataToTable] = useState([])
  const [buttonsPermissions, setButtonsPermissions] = useState({
    edit: false,
    show: false,
    delete: false,
  })

  // ------------ QUERIES AND MUTATIONS ------------
  const { loading, error, data, refetch } = useQuery(GET_HUMAN_RESOURCES, {
    variables: {
      searchQuery: pagePagination.searchQuery,
      limit: pagePagination.limit,
      offset: pagePagination.offset,
    },
    fetchPolicy: 'no-cache',
  })
  const [DeleteHumanResources] = useMutation(DELETE_HUMAN_RESOURCES)

  // ------------ EFFECTS ------------
  useEffect(() => {
    const permissions = user?.userPermissions
    const findPermission = permissions.find(
      (item) => item?.module_info?.relative_link === location.pathname
    )
    setButtonsPermissions({
      edit: findPermission?.access_edit || false,
      show: findPermission?.access_retrieve || false,
      delete: findPermission?.access_delete || false,
    })
  }, [location.pathname, user])

  useEffect(() => {
    if (!loading) {
      if (error)
        toastSweetAlert({
          mode: 'error',
          message: error.message,
        })

      let list = []
      data?.getHumanResources?.rows?.map((item) => {
        return list.push({
          id: item.id,
          Fotografía: (
            <img
              style={{ width: '100px', height: '100px', borderRadius: '13px' }}
              src={item?.photographFile?.url}
              alt={`userImage${item?.id}`}
            />
          ),
          Nombre: item.name,
          Apellido: item.last_name,
          accions_custom: (
            <div className="my-3 d-flex flex-column acciones">
              <div className="d-flex" style={{ gap: '5px' }}>
                {buttonsPermissions?.show && (
                  <Link
                    className="btn btn-orange btn-orange-cover btn-sm mb-1"
                    to={`humanResources/details/${item.id}/show`}
                    title="Ver detalles"
                  >
                    <i className="fas fa-eye mr-1" />
                  </Link>
                )}
                {buttonsPermissions?.edit && (
                  <Link
                    className="btn btn-orange btn-orange-cover btn-sm mb-1"
                    to={`humanResources/edit/${item.id}`}
                    title="Editar"
                  >
                    <i className="fas fa-edit mr-1" />
                  </Link>
                )}
                {buttonsPermissions?.delete && (
                  <button
                    className="btn btn-orange btn-orange-cover btn-sm mb-1"
                    title="Eliminar"
                    onClick={() => handleDelete(item.id)}
                  >
                    <i className="fas fa-trash mr-1" />
                  </button>
                )}
              </div>
            </div>
          ),
        })
      })
      setDataToTable(list)
      setTotal(data?.getHumanResources?.count || 0)
    }
  }, [loading, error, data])

  // ------------ FUNCTIONS ------------
  const handleDelete = async (id) => {
    MySwal.fire({
      showCloseButton: true,
      icon: 'warning',
      title: '¿Estas seguro de eliminar el registro?',
      html: (
        <>
          <div className="message-container">Esta accion es permanente</div>
        </>
      ),
      allowOutsideClick: false,
      buttonsStyling: false,
      showDenyButton: true,
      confirmButtonText: 'Aceptar',
      denyButtonText: 'Cancelar',
      reverseButtons: true,
      customClass: {
        title: 'StandarModalTitle',
        htmlContainer: 'StandarModalHtmlContainer',
        confirmButton: 'btn btn-orange',
        denyButton: 'btn StandarModalCancelButtonLogOut',
        footer: 'btn StandarModalFooterLogOut',
      },
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const response = await DeleteHumanResources({
            variables: {
              id,
            },
          })
          if (response) {
            refetch()
            return toastSweetAlert({
              mode: 'success',
              message: 'Registro eliminado correctamente',
            })
          } else {
            return toastSweetAlert({
              mode: 'error',
              message: 'Error al eliminar el registro',
            })
          }
        } catch (error) {
          return toastSweetAlert({
            mode: 'error',
            message: error.message,
          })
        }
      }
    })
  }
  return (
    <>
      <ContentHeader
        title="Recursos Humanos"
        breadcrumb="Recursos Humanos"
        windowTitle="Recursos Humanos"
      />
      <LayoutTable
        data={dataToTable}
        title="Lista de usuarios"
        // gql, requery, exportQuery pueden agregarse si existen las mutaciones correspondientes
        extraRefetchDelete={extraRef}
        totalCount={total}
        pagePagination={pagePagination}
        setPagePagination={setPagePagination}
        loadingData={loading}
        FilterBarPlaceholder="Buscar por nombre o apellido"
        hideDetails
        gql={DELETE_HUMAN_RESOURCES}
        hideActions
        hideId
      />
    </>
  )
}

export default HumanResources
